import type { OrderForm } from 'src/sdk/checkout/entity/orderForm'
import type { PageTypeResult } from 'src/hooks/usePageType'

import { checkCartType, getStandardObject } from './getStandardObject'
import { dispatchAmplitudeEvent } from './dispatchAmplitudeEvent'
import formatTotalizersTotal from './formatTotalizersTotal'
import { getCartItemsCount } from './cartEventValues'

export const sendValidateCEPEvent = ({
  orderForm,
  isCEPValid,
  pageData,
}: {
  orderForm: OrderForm
  isCEPValid: boolean
  pageData: PageTypeResult
}) => {
  const standardObject = getStandardObject(pageData)
  const eventName = isCEPValid
    ? 'CEP Validation Applied'
    : 'CEP Validation Error Displayed'

  dispatchAmplitudeEvent({
    eventName,
    eventData: {
      ...standardObject,
      'number cart items': getCartItemsCount(orderForm?.items),
      'value cart items': formatTotalizersTotal(
        orderForm?.totalizers?.total ?? 0
      ),
      'cart type': checkCartType(orderForm?.items),
    },
  })
}
